window.showMoreCards1621 = function (el) {
    let itemsList = el.closest('.content-card-list-1621').querySelectorAll('ul.content-card-list-1621__items__list')[0];

    if (itemsList) {
        let cardsPerRow = itemsList.classList.contains('three-col') ? 6 : 8;

        let hiddenCards = el.closest('.content-card-list-1621').querySelectorAll('ul.content-card-list-1621__items__list .hidden');

        if (hiddenCards) {
            let limit = hiddenCards.length > cardsPerRow ? cardsPerRow : hiddenCards.length;
            for (let i = 0; i < limit; i++) {
                hiddenCards[i].classList.remove('hidden');
            }

            let recheckHidden = el.closest('.content-card-list-1621').querySelectorAll('ul.content-card-list-1621__items__list .hidden');
            if (recheckHidden && recheckHidden.length === 0) {
                el.closest('.content-card-list-1621__items__more-items').classList.add('hidden');
            }
        }
    }
}